import * as React from "react";
import styled, { css } from "styled-components";

const StyledMedia = styled.div<IStyledMediaProps>`
  display: flex;
  ${(props) =>
    props.centred &&
    css`
      align-items: center;
    `}
`;

const Img = styled.div`
  margin-inline-end: ${({ theme }) => theme.space[2]};
`;

const Body = styled.div`
  flex: 1;
  /* For ElementInTable webname ellipsis */
  max-width: 100%;
  overflow: hidden;
`;

interface IStyledMediaProps {
  centred: boolean | undefined;
}

interface IMediaProps {
  img: React.ReactNode;
  centred?: boolean;
  children: React.ReactNode;
}

const Media: React.FC<IMediaProps> = ({ img, centred = false, children }) => (
  <StyledMedia centred={centred}>
    <Img>{img}</Img>
    <Body>{children}</Body>
  </StyledMedia>
);

export default Media;
